(() => {
  const assets = {"kampot":"https://cdn.shopify.com/s/files/1/1017/4539/4051/files/sinch-configurateur-kampot-master.png?v=1790045417","tao":"https://cdn.shopify.com/s/files/1/1017/4539/4051/files/sinch-configurateur-tao-master.png?v=1789207272","capri":"https://cdn.shopify.com/s/files/1/1017/4539/4051/files/sinch-configurateur-capri-master.png?v=1789207809","borneo":"https://cdn.shopify.com/s/files/1/1017/4539/4051/files/sinch-configurateur-borneo-master.png?v=1789207818","jaya":"https://cdn.shopify.com/s/files/1/1017/4539/4051/files/sinch-configurateur-jaya-master.png?v=1789207829","redang":"https://cdn.shopify.com/s/files/1/1017/4539/4051/files/sinch-configurateur-redang-master.png?v=1789207838","kuala":"https://cdn.shopify.com/s/files/1/1017/4539/4051/files/sinch-configurateur-kuala-master.png?v=1789207848"};
  const names = {kampot:'Kampot',tao:'Tao',kuala:'Kuala',capri:'Capri',borneo:'Bornéo',redang:'Redang',jaya:'Jaya'};
  function init(root = document) {
    const handle = decodeURIComponent(location.pathname.split('/products/')[1]?.split('/')[0] || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    if (!assets[handle]) return;
    const name = names[handle];
    root.querySelectorAll('.product-builder').forEach(builder => {
      if (builder.querySelector('[data-sinch-preview]') || !builder.querySelector('[data-color-choice="bag"]')) return;
      const card = document.createElement('div');
      card.className = 'sinch-preview-card';
      card.dataset.sinchPreview = '';
      card.innerHTML = '<div class="sinch-preview-card__title"></div><p data-sinch-status role="status" aria-live="polite">Choisissez une couleur pour afficher votre sac.</p><canvas hidden role="img"></canvas><p class="sinch-preview-card__hint">Simulation de couleurs. Les nuances peuvent varier selon le coton et votre écran. Les accessoires illustrés dépendent des options choisies.</p>';
      card.querySelector('.sinch-preview-card__title').textContent = 'Aperçu de votre ' + name;
      const anchor = builder.querySelector('.color-preview');
      if (anchor) anchor.before(card); else builder.prepend(card);
      const canvas = card.querySelector('canvas');
      const ctx = canvas.getContext('2d');
      const status = card.querySelector('[data-sinch-status]');
      let source, output, ready = false, failed = false, scheduled = false;
      const color = input => {
        const css = getComputedStyle(input.closest('.swatch-choice')).getPropertyValue('--swatch').trim();
        const probe = document.createElement('canvas').getContext('2d');
        probe.fillStyle = css || '#D9C3A7'; probe.fillRect(0,0,1,1);
        return [...probe.getImageData(0,0,1,1).data].slice(0,3);
      };
      function update() {
        scheduled = false;
        const p = builder.querySelector('[data-color-choice="bag"]:checked');
        const toggle = builder.querySelector('[data-second-color-toggle]');
        const s = toggle?.checked ? builder.querySelector('[data-color-choice="second"]:checked') : null;
        if (!p) { canvas.hidden = true; status.textContent = 'Choisissez une couleur pour afficher votre sac.'; return; }
        if (!ready) { canvas.hidden = true; status.textContent = failed ? 'Aperçu indisponible. Vous pouvez continuer à choisir vos couleurs.' : 'Chargement de votre aperçu…'; return; }
        const primary = color(p), secondary = s ? color(s) : primary;
        const data = output.data;
        for (let i=0; i<source.length; i+=4) {
          const r=source[i], g=source[i+1], b=source[i+2];
          const hi=Math.max(r,g,b), lo=Math.min(r,g,b), chroma=hi-lo;
          if (chroma > 18 && ((r>=b && r>g*1.4 && b>=g*0.72) || (b>r && b>g*1.18))) {
            const target = r >= b ? primary : secondary;
            const shade = Math.min(1,hi/220);
            const highlight = Math.max(0,(hi-220)/35)*0.22;
            for (let c=0;c<3;c++) data[i+c]=Math.round(target[c]*shade+(255-target[c])*highlight);
          } else { data[i]=r; data[i+1]=g; data[i+2]=b; }
          data[i+3]=source[i+3];
        }
        ctx.putImageData(output,0,0);
        canvas.hidden=false;
        const label = s ? p.value + ' + ' + s.value : p.value;
        status.textContent=label;
        canvas.setAttribute('aria-label','Aperçu du sac '+name+' : '+label);
      }
      function schedule() { if(!scheduled) { scheduled=true; requestAnimationFrame(update); } }
      builder.addEventListener('change',event => { if(event.target.matches('[data-color-choice], [data-second-color-toggle]')) schedule(); });
      const img=new Image(); img.crossOrigin='anonymous';
      img.onload=()=> {
        try {
          canvas.width=Math.min(900,img.naturalWidth); canvas.height=Math.round(img.naturalHeight*canvas.width/img.naturalWidth);
          ctx.drawImage(img,0,0,canvas.width,canvas.height);
          source=ctx.getImageData(0,0,canvas.width,canvas.height).data;
          output=ctx.createImageData(canvas.width,canvas.height); ready=true; update();
        } catch(error) { failed=true; update(); }
      };
      img.onerror=()=> { failed=true; update(); };
      img.src=assets[handle]+'&width=900';
      update();
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(),{once:true}); else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
